<script lang="ts" setup>
import AirlinePricingForm from "@/data-views/forms/airline_pricing/Form.vue";
definePage({
  meta: {
    action: "update",
    subject: "AirlinePricing",
  },
});
</script>

<template>
  <div>
    <AirlinePricingForm />
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/libs/apex-chart.scss";
</style>
